import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Swal from "sweetalert2";
import { GetProductByIdApi } from "../../common/CommonApi";

const ViewProduct = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [productDetails, setProductDetails] = useState({});
  const navigate = useNavigate();
  const hasAttribute = (attributeKey) => Object.prototype.hasOwnProperty.call(
    productDetails.attributes || {},
    attributeKey
  );

  useEffect(() => {
    FetchData();
  }, []);

  const FetchData = async () => {
    const resp = await GetProductByIdApi(id);
    if (resp.data.message === "DATA_FOUND") {
      setProductDetails(resp.data.data);
    }
  };

  return (
    <div style={{ padding: "10px 20px", background: "#fff" }}>
      <Header>View Product Details</Header>

      <Grid>
        <InputBox label="Name" name="name" value={productDetails.name} />
        <InputBox
          label="Short Description"
          name="shortDescription"
          value={productDetails.shortDescription}
        />
        <InputBox
          label="Description"
          name="description"
          value={productDetails.description}
        />
        <InputBox
          label="Product Details"
          name="productDetails"
          value={productDetails.productDetails}
        />
        {/* <InputBox
          label="Price"
          name="price"
          type="number"
          value={productDetails.price}
        />
        <InputBox
          label="Discounted Price"
          name="disCountedprice"
          type="number"
          value={productDetails.disCountedprice}
        /> */}
        <InputBox
          label="Style Tags"
          name="styleTags"
          value={productDetails.styleTags}
        />
        <InputBox
          label="Care Instructions"
          name="careInstructions"
          value={productDetails.careInstructions}
        />
        {!hasAttribute("Season") && (
          <InputBox label="Season" name="season" value={productDetails.season} />
        )}
        {!hasAttribute("Material") && !hasAttribute("Fabric") && (
          <InputBox label="Material" name="material" value={productDetails.material} />
        )}
        {Object.entries(productDetails.attributes || {}).map(([attributeKey, attributeValue]) => (
          <InputBox
            key={attributeKey}
            label={attributeKey}
            name={attributeKey}
            value={attributeValue}
          />
        ))}
         <Grid2>

        <InputBox
          label="Pkg Length(cm)"
          name="length"
          value={productDetails.length}
        />
        <InputBox
          label="Pkg Width(cm)"
          name="width"
          value={productDetails.width}
        />
        <InputBox
          label="Pkg Height(cm)"
          name="height"
          value={productDetails.height}
        />
         </Grid2>
        <InputBox
          label="Try and Buy"
          name="trynbuy"
          value={productDetails.trynbuy ? 'Yes' : 'No'}
        />
        {!hasAttribute("Sleeve Type") && (
          <InputBox label="Sleeve Type" name="sleevetype" value={productDetails.sleevetype} />
        )}
        {!hasAttribute("Neck Type") && (
          <InputBox label="Neck Type" name="necktype" value={productDetails.necktype} />
        )}
        {!hasAttribute("Pattern") && (
          <InputBox label="Pattern" name="pattern" value={productDetails.pattern} />
        )}
        {!hasAttribute("Fit") && (
          <InputBox label="Fit Type" name="fittype" value={productDetails.fittype} />
        )}
        <InputBox
          label="Store / Pickup location "
          name="pickup"
          value={productDetails.pickup}
        />
         <InputBox
          label="HSN Tax Code"
          name="HsnTaxCode"
          value={productDetails.HsnTaxCode}
        />
         <InputBox
          label="Origin By"
          name="originBy"
          value={productDetails.originBy}
        />
         <InputBox
          label="Manufactured By"
          name="manufactured"
          value={productDetails.manufactured}
        />
      </Grid>

      {/* --- IMAGES SECTION --- */}
      {/* <SectionTitle>Global Images</SectionTitle>
      <ImageContainer>
        {productDetails.images?.map((img, index) => (
          <ImageBox key={index}>
            <ProductImage src={img} alt="product" />
          </ImageBox>
        ))}
      </ImageContainer> */}

      {/* --- VARIANTS SECTION --- */}
      <SectionTitle>Variants</SectionTitle>
      {productDetails.variants?.length > 0 ? (
        productDetails.variants.map((v, index) => (
          <VariantBox key={index} style={{background:"#ececec"}}>
            <label style={{color:"black",fontWeight:1000}}>{'Variant- ' + (index+1)}</label>
            <VariantRow>
            <InputWrapper>
                <Label2>Color</Label2>
                <VariantInput placeholder={v.color} value={v.color} readOnly />
            </InputWrapper>
              <InputWrapper>
                <Label2>Size</Label2>
                <VariantInput placeholder={v.size} value={v.size} readOnly />
            </InputWrapper>
              {/* <InputWrapper>
                <Label2>Material</Label2>
                <VariantInput placeholder={v.material} value={v.material} readOnly />
            </InputWrapper> */}
              <InputWrapper>
                <Label2>Price</Label2>
                <VariantInput placeholder={v.price} value={v.price} readOnly />
            </InputWrapper>
              <InputWrapper>
                <Label2>Discounted Price</Label2>
                <VariantInput placeholder={v.disCountedprice} value={v.disCountedprice} readOnly />
            </InputWrapper>
            <InputWrapper>
                <Label2>Quantity</Label2>
                <VariantInput placeholder={v.quantity} value={v.quantity} readOnly />
            </InputWrapper>
            <InputWrapper>
                <Label2>SKU</Label2>
                <VariantInput placeholder={v.sku} value={v.sku} readOnly />
            </InputWrapper>
            </VariantRow>
            <ImageContainer style={{marginTop:"10px"}}>
            {v.varientImages?.map((img, index) => (
              <ImageBox key={index}>
                <ProductImage src={img} alt="product" />
              </ImageBox>
            ))}
          </ImageContainer>
          </VariantBox>
        ))
      ) : (
        <p style={{ color: "#6b7280" }}>No variants available</p>
      )}

      <br />
      <ButtonRow>
        <BackButton type="button" onClick={() => navigate("/products")}>
          Back to Products
        </BackButton>
      </ButtonRow>
    </div>
  );
};

export default ViewProduct;

//
// ---------------- Styled Components ----------------
//

const Header = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
`;

const Input = styled.input`
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: #f9fafb;
  cursor: not-allowed;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0 8px 0;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const ImageBox = styled.div`
  position: relative;
`;

const ProductImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const VariantBox = styled.div`
  background: #f9fafb;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
`;

const VariantRow = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Label2 = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
`;

const VariantInput = styled.input`
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background-color: #f9fafb;
  cursor: not-allowed;
  font-size: 14px;
  color: #111827;
`;


const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

const BackButton = styled.button`
  background: #2563eb;
  color: #fff;
  padding: 8px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #1e40af;
  }
`;

const InputBox = ({ label, name, value, type = "text" }) => (
  <Field>
    <Label>{label}</Label>
    <Input name={name} value={value || ""} type={type} readOnly />
  </Field>
);
